import React, { useState, useEffect } from 'react';
import Input from '../../../components/ui/Input';
import Button from '../../../components/ui/Button';


const SearchBar = ({ onSearch, isLoading }) => {
  const [phoneNumber, setPhoneNumber] = useState('');
  const [error, setError] = useState('');

  const formatPhoneNumber = (value) => {
    const cleaned = value?.replace(/\D/g, '');
    
    if (cleaned?.length === 0) return '';
    if (cleaned?.length <= 3) return cleaned;
    if (cleaned?.length <= 6) return `(${cleaned?.slice(0, 3)}) ${cleaned?.slice(3)}`;
    return `(${cleaned?.slice(0, 3)}) ${cleaned?.slice(3, 6)}-${cleaned?.slice(6, 10)}`;
  };

  const normalizeToE164 = (value) => {
    const digits = value?.replace(/\D/g, '');
    if (digits?.length === 10) return `+1${digits}`;
    if (digits?.length === 11 && digits?.startsWith('1')) return `+${digits}`;
    return null;
  };

  const validatePhoneNumber = (value) => {
    const digits = value?.replace(/\D/g, '');
    if (digits?.length === 0) {
      setError('');
      return false;
    }
    if (digits?.length === 10) {
      setError('');
      return true;
    }
    if (digits?.length === 11 && digits?.startsWith('1')) {
      setError('');
      return true;
    }
    setError('Phone number must be 10 digits (or 11 digits starting with 1)');
    return false;
  };

  const handleChange = (e) => {
    const value = e?.target?.value;
    const cleaned = value?.replace(/\D/g, '');
    
    if (cleaned?.length <= 11) {
      // For 10-digit input, apply pretty formatting; otherwise store raw digits
      if (cleaned?.length <= 10) {
        setPhoneNumber(formatPhoneNumber(value));
      } else {
        setPhoneNumber(cleaned);
      }
      validatePhoneNumber(value);
    }
  };

  const handleSubmit = (e) => {
    e?.preventDefault();
    
    if (validatePhoneNumber(phoneNumber)) {
      const e164Format = normalizeToE164(phoneNumber);
      if (e164Format) {
        console.log('Normalized phone before RPC call:', e164Format);
        onSearch(e164Format, phoneNumber);
      }
    }
  };

  const handleClear = () => {
    setPhoneNumber('');
    setError('');
  };

  return (
    <form onSubmit={handleSubmit} className="w-full">
      <div className="flex flex-col sm:flex-row gap-3">
        <div className="flex-1">
          <Input
            type="tel"
            label="Driver Phone Number"
            placeholder="(555) 123-4567"
            value={phoneNumber}
            onChange={handleChange}
            error={error}
            disabled={isLoading}
            required
            className="w-full"
          />
        </div>
        <div className="flex gap-2 sm:mt-6">
          {phoneNumber && (
            <Button
              type="button"
              variant="outline"
              size="lg"
              iconName="X"
              onClick={handleClear}
              disabled={isLoading}
              className="sm:w-auto"
            >
              Clear
            </Button>
          )}
          <Button
            type="submit"
            variant="default"
            size="lg"
            iconName="Search"
            iconPosition="left"
            loading={isLoading}
            disabled={!phoneNumber || !!error || isLoading}
            className="flex-1 sm:flex-none"
          >
            Search Driver
          </Button>
        </div>
      </div>
      <p className="text-xs text-muted-foreground mt-2">
        Enter 10-digit US phone number to lookup driver information
      </p>
    </form>
  );
};

export default SearchBar;